import { HeadSEO } from "@/components/SEO/HeadSEO";
import * as StyledLayout from "@/layouts/Styled.Layout";
import * as StyledTypography from "@/styles/Styled.Typography";
import * as StyledButtons from "@/styles/Styled.Buttons";

export default function ConfirmSubscription() {
  return (
    <>
      <HeadSEO
        siteTitle="Confirm Subscription"
        siteDescription="Thanks for subscribing!"
        noindex={true} // <-- triggers robots and prevents structured data
      />
      <StyledTypography.ParadoxSubtitle as="h2" data-animate="fade-up">
        Confirmed: You Now Belong to Our Inbox Club.
      </StyledTypography.ParadoxSubtitle>
      <StyledLayout.Grid>
        <StyledLayout.GridItem>
          <p>
            Boom! You're officially confirmed and on the list. Expect some great
            emails headed your way very soon.
          </p>
          <p>
            As promised, here's your FREE Notion Anti-Procrastination Planner.
            You are welcome.
          </p>
          <StyledButtons.PrimaryButton as="button">
            <a href="https://imstanleyyeo.notion.site/Anti-Procrastination-Planner-Based-On-GTD-Framework-v1-0-3e4408178d4c46cabfb648d0ec8a7f62?pvs=4">
              Let's Get My FREE Template
            </a>
          </StyledButtons.PrimaryButton>
        </StyledLayout.GridItem>
      </StyledLayout.Grid>
    </>
  );
}
